// src/Common/Components/CommonComponents.js

// ✅ Example: Dropdown values
export const ClassListArray = [
  { name: 'Nursery', value: 'Nursery' },
  { name: 'LKG', value: 'LKG' },
  { name: 'UKG', value: 'UKG' },
  { name: 'Class 1', value: '1' },
  { name: 'Class 2', value: '2' },
  { name: 'Class 3', value: '3' },
  { name: 'Class 4', value: '4' },
  { name: 'Class 5', value: '5' },
  { name: 'Class 6', value: '6' },
  { name: 'Class 7', value: '7' },
  { name: 'Class 8', value: '8' },
  { name: 'Class 10', value: '10' }
];